const redirectPage = document.querySelector('[data-page="redirect"]');

if (redirectPage) {
  const redirectRoute = redirectPage.dataset.route;

  if (redirectRoute) {
    let timer = setTimeout(() => {
      window.location.href = redirectRoute;

      clearTimeout(timer);
    }, 2000);
  }
}

window.addEventListener("load", () => {
  const hash = window.location.hash;

  if (hash) {
    const anchorName = hash.substring(1);
    const anchor = document.querySelector(`[data-section="${anchorName}"]`);
    if (anchor) {
      setTimeout(() => {
        anchor.scrollIntoView({ behavior: "smooth", block: "start" });
        history.replaceState(null, null, window.location.pathname);
      }, 800);
    }
  }
});
